import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter as Router } from 'react-router-dom';
import { ErrorBoundary } from '@hungryroot/component-error-boundary';
import { DevModeHead } from '@hungryroot/dev-mode';
import { ExperimentOverrides } from '@hungryroot/experiments';
import { queryClient } from '@hungryroot/rest';
import { renderApp } from '../../frontend/react/src/utils/utils';

// Experiment
import { QuizComponent } from './QuizComponent';

// making sure ajax don't fail
// This is already in base_v3.coffee we are either overriding it or setting depending
// on which runs first.
$.ajaxSetup({
  xhrFields: {
    withCredentials: true,
  },
  beforeSend: function (xhr, settings: { type: string }) {
    xhr.setRequestHeader(
      'AUTHORIZATION',
      'c61de580-e48d-41d2-a8d1-6cd1429987a1'
    );
    if (!/^(GET|HEAD|OPTIONS|TRACE)$/.test(settings.type) && this.crossDomain) {
      // We need to re-fetch the cookie here every time just in case we have logged in the user without
      // a page refresh (as it happened when exp_22 came in. See: https://www.pivotaltracker.com/story/show/163027230)
      xhr.setRequestHeader('X-CSRFToken', $.cookie('csrftoken'));
    }
  },
});

Object.defineProperty($, 'browser', {
  value: {
    mobile: window.matchMedia('only screen and (max-device-width: 800px)')
      .matches,
    phone: window.matchMedia('only screen and (max-device-width: 640px)')
      .matches,
  },
  enumerable: true,
  writable: true,
});

renderApp(
  <>
    {process.env.PUBLIC_HR_ENV !== 'production' && <DevModeHead />}
    <ExperimentOverrides />
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <Router>
          <QuizComponent testid="quiz" />
        </Router>
      </QueryClientProvider>
    </ErrorBoundary>
  </>,
  'survey-app'
);
